import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { partyMasterPageTabIds, partyMasterPageTabs } from '../GSConstants'
import PartyConfigTable from './PartyConfig/PartyConfigTable'
import PartyRateMatrixTable from './PartyRateMatrix/PartyRateMatrixTable'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import CorporateRateMatrixNew from './CorporateRateMatrix/CorporateRateMatrixNew'
import { PartyWiseConsignmentList } from './partywiseConsignmentList'
import useToken from '../../../helpers/useTokens'
import { DEMO_COMPANY, RAJESH_TRANSPORT } from '../../../../helper/companyIdhardcode'
import { useTranslation } from '../../../../i18n/I18nProvider'

const GSPartyMasterPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || 1)
  const [tabData, setTabData] = useState({})
  const { loginData } = useToken()
  const { intCompanyID } = loginData
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const partyMasterPageTabsAll =
    [RAJESH_TRANSPORT, DEMO_COMPANY].includes(intCompanyID)
      ? [...partyMasterPageTabs, { name: 'PartyWise cosnignment list', translationKey: 'partyWiseConsignmentList', JobID: 4 }]
      : partyMasterPageTabs

  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1')
    const allGSPagesActive = JSON.parse(allGSPages)
    if (selectedTab === '' || selectedTab === undefined) {
      const newData = partyMasterPageTabsAll.filter((item) =>
        findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', 'IsActive') === 1 ? item : null
      )
      goToTabs(newData?.[0]?.JobID, {})
    }
  }, [searchParams, selectedTab])
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab, data) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
    setTabData(data)
  }
  const getPartyMasterPageContent = (typeId, label) => {
    switch (typeId) {
      case 1:
        return <PartyConfigTable goToTabs={goToTabs} tabData={tabData} />
      case 2:
        return <CorporateRateMatrixNew goToTabs={goToTabs} tabData={tabData} />
      case 3:
        return <PartyRateMatrixTable />
      case 4:
        return <PartyWiseConsignmentList />
      default:
        return label
    }
  }
  return (
    <>
      <Box className="partyMasterPageTabContainer">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={(e, newValue) => goToTabs(newValue, {})} aria-label="bsic tabs example">
              {partyMasterPageTabsAll.map((reqType, index) => (
                <Tab
                  key={`sender_${index}`}
                  value={reqType.JobID}
                  label={gs?.[reqType.translationKey] || reqType.name}
                  {...partyMasterPageTabIds(reqType.JobID)}
                  sx={{
                    display: 'block',
                    //       findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                    //         ? 'block'
                    //         : 'none',
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {partyMasterPageTabsAll.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`partyMasterPage-tabpanel-${index}`}
              aria-labelledby={`partyMasterPage-tab-${index}`}
              key={`senderSe_${index}`}
              style={{
                display: 'block',
                // findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID',"IsActive")===1
                //   ? 'block'
                //   : 'none',
              }}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getPartyMasterPageContent(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default GSPartyMasterPage
